import { EMPTY_EBIS_INTERFACE_MONITORINGANY_MODEL } from "presentation/model/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: EbisInterfaceMonitoringMaintenanceProvider,
    useTracked: useEbisInterfaceMonitoringMaintenanceTracked
} = createContainer(() => useState(EMPTY_EBIS_INTERFACE_MONITORINGANY_MODEL), {concurrentMode: true});
export { EbisInterfaceMonitoringMaintenanceProvider, useEbisInterfaceMonitoringMaintenanceTracked };

